@let certification = etape().certification;

<div
  class="py-sm px-md gap-lg border-stroke-neutral-light flex h-full flex-col rounded-lg border"
  [class]="userClass()"
>
  <div class="flex justify-between">
    <div class="gap-xs flex flex-col">
      <div class="gap-xs flex">
        @if (certification && certification.type) {
          <app-chip [label]="certification.type" />
        }
        <ng-content select="etat" />
      </div>
      <div class="flex flex-col">
        <span class="component-medium-semibold text-content-primary">{{ etape().nom }}</span>
        <span class="component-small-medium text-content-secondary">{{
          etape().idReferentiel | convertIdReferentielToNom
        }}</span>
      </div>
    </div>
    <ng-content />
  </div>
  <div class="gap-md grid">
    <ng-container
      [ngTemplateOutlet]="item"
      [ngTemplateOutletContext]="{
        icone: 'lucideBriefcase',
        label: etape().typesContrat ? (etape().typesContrat | convertTypesContratToString) : 'Non renseigné',
      }"
    />

    <div class="flex flex-col">
      <ng-container
        [ngTemplateOutlet]="item"
        [ngTemplateOutletContext]="{
          icone: 'lucideBadgeCheck',
          label: certification ? 'Diplômante' : 'Non diplômante',
        }"
      />
      @if (certification) {
        <p class="text-content-tertiary component-small-medium pl-lg">
          {{ certification.nom }} - {{ certification.codeFiche }}
        </p>
      }
    </div>
    <ng-container
      [ngTemplateOutlet]="item"
      [ngTemplateOutletContext]="{
        icone: 'lucideMapPin',
        label: etape().modalite?.nom ?? 'Non renseigné',
      }"
    />

    <ng-container
      [ngTemplateOutlet]="item"
      [ngTemplateOutletContext]="{
        icone: 'lucideTicketCheck',
        label: etape().publicsCibles,
      }"
    />
    @if (showGroupes()) {
      <div class="gap-xs flex">
        <ng-icon name="lucideUsers" hlm size="sm" />
        <div class="gap-xs component-small-medium grid">
          <div class="gap-xxs grid">
            <span>1ère année</span>
            <span class="text-components-content-neutral-tertiary">{{
              (etape().groupes ?? [] | filtrerParAnnee: 1).length | i18nPlural: groupeMapping
            }}</span>
          </div>
          <div class="gap-xxs grid">
            <span>2ème année</span>
            <span class="text-components-content-neutral-tertiary">{{
              (etape().groupes ?? [] | filtrerParAnnee: 2).length | i18nPlural: groupeMapping
            }}</span>
          </div>
          <div class="gap-xxs grid">
            <span>3ème année</span>
            <span class="text-components-content-neutral-tertiary">{{
              (etape().groupes ?? [] | filtrerParAnnee: 3).length | i18nPlural: groupeMapping
            }}</span>
          </div>
        </div>
      </div>
    }
  </div>
</div>

<ng-template #item let-icone="icone" let-label="label">
  <div class="gap-xs flex items-center">
    <div class="text-components-content-neutral-tertiary">
      <ng-icon [name]="icone" hlm size="sm" />
    </div>
    <span class="component-small-medium">{{ label }}</span>
  </div>
</ng-template>
